import React from 'react';
import PropTypes from 'prop-types';

const DEFAULT_ICON_SIZE = 24;

const sizePropType = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);

const CoinsIcon = ({ w, h, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        fillRule="evenodd"
        d="M2 13.737V11.42c0 1.279 2.634 2.316 5.882 2.316 3.249 0 5.883-1.037 5.883-2.316v2.316c0 1.279-2.634 2.316-5.883 2.316C4.634 16.053 2 15.016 2 13.737zm0 3.474v-2.316c0 1.279 2.634 2.316 5.882 2.316 3.249 0 5.883-1.037 5.883-2.316v2.316c0 1.278-2.634 2.315-5.883 2.315C4.634 19.526 2 18.49 2 17.211zm0 3.473v-2.316c0 1.28 2.634 2.316 5.882 2.316 3.249 0 5.883-1.037 5.883-2.316v2.316c0 1.28-2.634 2.316-5.883 2.316C4.634 23 2 21.963 2 20.684zm8.235-17.368C10.235 2.036 12.87 1 16.118 1S22 2.037 22 3.316s-2.634 2.316-5.882 2.316c-3.25 0-5.883-1.037-5.883-2.316zm5.883 13.895c3.248 0 5.882-1.037 5.882-2.316v2.316c0 1.278-2.634 2.315-5.882 2.315-.404 0-.797-.016-1.177-.046v-2.316c.38.03.773.047 1.177.047zm0-6.948c3.248 0 5.882-1.037 5.882-2.316v2.316c0 1.279-2.634 2.316-5.882 2.316-.404 0-.797-.016-1.177-.046v-2.27c0-.016-.005-.03-.005-.047.382.031.777.047 1.182.047zm0-3.474C19.366 6.79 22 5.753 22 4.474v2.315c0 1.28-2.634 2.316-5.882 2.316-.577 0-1.132-.034-1.658-.094-.736-.937-2.272-1.675-4.198-2.015a.944.944 0 0 1-.027-.207V4.474c0 1.279 2.634 2.315 5.883 2.315zm0 6.948C19.366 13.737 22 12.7 22 11.42v2.316c0 1.279-2.634 2.316-5.882 2.316-.404 0-.797-.016-1.177-.047V13.69c.38.03.773.046 1.177.046zm-2.353-3.474c0 1.279-2.634 2.316-5.883 2.316C4.634 12.579 2 11.542 2 10.263s2.634-2.316 5.882-2.316c3.249 0 5.883 1.037 5.883 2.316z"
      />
    </svg>
  );
};

CoinsIcon.propTypes = {
  w: sizePropType,
  h: sizePropType,
};

CoinsIcon.defaultProps = {
  w: DEFAULT_ICON_SIZE,
  h: DEFAULT_ICON_SIZE,
};

CoinsIcon.ICON_SIZE = DEFAULT_ICON_SIZE;

export default CoinsIcon;
